import React, { useEffect } from 'react'
import { TabPanel } from 'primereact/tabview'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { PageHeader, CustomPanel, CustomTabView, HeaderText } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import FaltasManualPorIdentificador from './FaltasManual/FaltasManualPorIdentificador'
import SobrasManual from './SobrasManual/SobrasManual'
import EmitirResumo from '../ResumoSeparacao/EmitirResumo/EmitirResumo'
import useResumoSeparacaoManual, { LOAD_MESSAGE } from './ResumoSeparacaoManualHook'
import FaltasManualPorRota from './FaltasManual/FaltasManualPorRota'

function ResumoSeparacaoManual({ dispatch, history, selectedPicking }) {
  const { state, localDispatch } = useResumoSeparacaoManual()

  useEffect(() => {
    if (selectedPicking) localDispatch.onInit()
    else history.goBack()
  }, [selectedPicking])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getResumoSeparacaoManualInfo(selectedPicking)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>
        <span>Resumo de Separação Manual:</span>
        <strong>
          {selectedPicking ? `${selectedPicking.name} - ${selectedPicking.company_name}` : ''}
        </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <CustomTabView activeIndex={state.tabActiveIndex}>
            <TabPanel header="Apuração das Faltas" disabled={false}>
              <HeaderText>Apontamento das Faltas Apuradas</HeaderText>
              <CustomTabView activeIndex={state.tabFaltasIndex}>
                <TabPanel header="Faltas por Identificador">
                  <FaltasManualPorIdentificador
                    missing_products={state.missing_products.byIdentifier}
                  />
                </TabPanel>
                <TabPanel header="Faltas por Rota">
                  <FaltasManualPorRota
                    missing_products={state.missing_products.byRoute}
                    missing_reasons={state.missing_products.byIdentifier.missing_reasons}
                  />
                </TabPanel>
              </CustomTabView>
            </TabPanel>
            <TabPanel header="Sobras" disabled={false}>
              <SobrasManual
                leftover_products={state.leftover_products.products}
                reasons={state.leftover_products.missing_reasons}
              />
            </TabPanel>
            <TabPanel header="Resumo de Separação" disabled={false}>
              <EmitirResumo
                faltasItems={state.missing_products.byIdentifier}
                sobrasItems={state.leftover_products.products}
                tipo="Manual"
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(withRouter(ResumoSeparacaoManual))
